<template>
  <div class="campaign">
    <div class="campaign__header">
      <div class="campaign__header__back">
        <i class="adx-ic_arrow_left"></i>
        <span class="text" @click.stop="goToListCampaign">Campaigns</span>
      </div>
      <div class="campaign__header__title">
        <h2 class="medium-title">Edit Campaign</h2>
      </div>
    </div>
    <div class="campaign__main">
      <div class="campaign__main__left">
        <div class="campaign__main__left__campaign_selection">
          <adx-input 
            label="Campaign Name"
            :value.sync="model.titleinput"
            :validation="['NewNotEmpty']"
            :ref="dataRef.titleinput"
            :error.sync="errors.campaignError" />
        </div>
        <div v-for="(listing, index) in model.listings" :key="index" class="campaign__main__left__location_placement">
          <h1>Locations</h1>
          <div class="campaign__main__left__location_placement__top">
            <adx-input 
              label="Location"
              :value.sync="listing.location"
              :ref="`location_${index}`"
            />
            <div class="icon-wrapper"><i @click="deleteListing(model.listings, index)" class="icon-deleted"></i></div>
          </div>
          <div v-if="listing.latitude && listing.longitude" class="campaign__main__left__location_placement__bottom">Coordinate have been set <span @click="openModalCoordinate(index)" class="change">Change</span></div>
          <div v-else class="campaign__main__left__location_placement__bottom"><span @click="openModalCoordinate(index)" class="set">Set Coordinate</span></div>
          <h1>Placement Per Location ({{countPlacement(listing.placements)}}) </h1>
          <div v-for="(placement, index_placement) in listing.placements" :key="index_placement" class="campaign__main__left__location_placement__placement">
             <adx-input label="Placement" :value.sync="placement.item" :ref="`placement_${index}_${index_placement}`"/>
             <div class="icon-wrapper"><i @click="deletePlacement(listing, index_placement)" class="icon-deleted"></i></div>
          </div>
          <div class="line-wrapper">
            <hr class="line">
          </div>
          <div class="campaign__main__left__location_placement__more-placement">
            <span class="text" @click.stop="addPlacement(listing)">Add More Placement</span>
          </div>
        </div>
        <button type="button" class="secondary btn-block" @click.stop="addListing(model.listings)">Add More</button>
      </div>
      <div class="campaign__main__right">
        <div class="campaign__main__right__date">
          <adx-single-search-dropdown :label="`Owner`" class="dropdown" :value.sync="model.owner" :optionsParam="userOptions"/>
        </div>
        <div class="campaign__main__right__date">
          <div :class="['calendar', startDate == null && !startDateIsValid ? 'warning' : '']">
            <label class="small-font">Start Date</label>
            <v-date-picker
              v-model='campaignDate.start'
              :min-date='new Date()'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                ref="startDate"
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
          <div :class="['calendar', endDate == null && !endDateIsValid ? 'warning' : '']">
            <label class="small-font">End Date</label>
            <v-date-picker
              v-model='campaignDate.end'
              :min-date='startDate ? startDate : new Date()'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                ref="endDate"
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
        </div>
        <button type="button" class="primary btn-block" @click.stop="saveCampaign">Save Campaign</button>
      </div>
    </div>
    <adx-modal
      v-if="showModalCoordinate"
      type="small"
      title="Set Coordinate"
      :hideClose="true"
    >
      <div slot="content" class="campaign__modal">
        <div class="campaign__modal__search_map">
          <i class="adx-ic_search"></i>
          <gmap-autocomplete
            @place_changed="setPlace">
          </gmap-autocomplete>
        </div>
        <GmapMap
          :center="center"
          :zoom="15"
          map-type-id="terrain"
          style="width: 100%; height: 200px"
          ref="mapRef"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false
          }"
        >
          <GmapMarker
            :position="center"
            :clickable="false"
            :draggable="false"
          />
        </GmapMap>
        <div class="campaign__modal__place_data">
          <span>Country <strong>{{currentPlace ? currentPlace.country.long_name : 'Indonesia'}}</strong></span>
          <span>Province <strong>{{currentPlace ? currentPlace.province.long_name : 'DKI Jakarta'}}</strong></span>
          <span>City <strong>{{currentPlace ? currentPlace.city.long_name : 'Jakarta Selatan'}}</strong></span>
          <span>Area <strong>{{currentPlace ? currentPlace.area.long_name : 'Kuningan'}}</strong></span>
          <span>Address <strong>{{currentPlace ? currentPlace.address : ''}}</strong></span>
        </div>
        <div class="campaign__modal__buttons">
          <div class="campaign__modal__buttons__cancel">
            <button type="button" class="secondary btn-block" @click.stop="closeModalCoordinate">Cancel</button>
          </div>
          <div class="campaign__modal__buttons__save">
            <button type="button" class="primary btn-block" @click.stop="saveCoordinate" :disabled="!currentPlace">Save</button>
          </div>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import calendar from 'v-calendar'
import lib from '@/lib/util'
import moment from 'moment'
import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'

import triggerValidation from "@/lib/triggerValidation";
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { constants } from 'crypto';

export default {
  name: 'adx-monitoring-new-campaign',
  components: {
    'adx-input': Input,
    'adx-modal': Modal,
    'adx-single-search-dropdown': SingleSearchDropdown,
  },
  props: {

  },
  data() {
    return {
      isLoading: true,
      showModalCoordinate: false,
      isShowModalCoordinate: false,
      currentPlace: null,
      locationIndex: null,
      isCoordinatSet: false,
      center: {
        lat: -7.090910999999999, lng: 107.668887
      },
      totalRow: 1,
      model: {
        titleinput: null,
        listings: [
          {
            coordinate : null,
            location : null,
            placements: [
              {
                item: null,
                id: null
              }
            ]
          }
        ],
        owner: null
      },
      campaignDate: {
        start: null,
        end: null,
      },
      dataRef: {
        titleinput: 'titleinput'
      },
      errors: {
        campaignError: null
      },
      inputDate: null,
      startDate: null,
      endDate: null,
      startDateIsValid: true,
      endDateIsValid: true,
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ],
      userOptions: [],
      owner: null,
    }
  },
  computed: {
    
  },
  watch: {
    'model.listings': {
      handler: function () {

      },
      deep: true
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.id = this.$route.params.id
  },
  mounted() {
    this.loadData()
    this.getUserOwner()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getUserOwner(){
      (async () =>{
        const { data } = await api.get(apiV2.getUser, { needToken: true })
        data.results.map(user => {
          this.userOptions.push(
            {
              value: user.id,
              label: user.email
            }
          )
        })
    })();
    },
    async loadData() {
      this.isLoading = true
      const { data } = await api.get(apiV2.taskManagerCampaignEdit(this.id), {needToken: true})

      const start = moment(data.start,'DD/MM/YYYY').toDate()
      const end = moment(data.end,'DD/MM/YYYY').toDate()

      this.model.titleinput = data.title
      this.campaignDate.start = start
      this.campaignDate.end = end
      this.model.listings = data.listing_set
      this.model.owner = data.owner
      this.mapListing(this.model.listings)
    },
    mapListing(listings){
      let newListings = {}
      let tempListings = []

      listings.map(listing => {
        if (Object.keys(newListings).includes(listing.location_name)) {
          newListings[listing.location_name]['placements'].push(listing.placement)
        } else {
          newListings[listing.location_name] = listing
          newListings[listing.location_name]['placements'] = []
          newListings[listing.location_name]['placements'].push(listing.placement)
          delete newListings[listing.location_name]['placement']
        }
      })
      for (const [key, value] of Object.entries(newListings)) {
        let tempValue = {}
        let finalPlacement = []
        value.placements.forEach(item => {
          finalPlacement.push({item: item, id: ''})
        })
        tempValue = {
          'area' :  value.area,
          'city' : value.city,
          'start' : value.start,
          'end' : value.end,
          'latitude' : value.latitude,
          'longitude' : value.longitude,
          'location' : value.location_name,
          'placements': finalPlacement,
          'id': value.id
        }
        tempListings.push(tempValue)
      }
      this.model.listings = tempListings
      this.isLoading = false
    },
    deleteItem(index) {
      this.model.listings.splice(index, 1)
    },
    setPlace(place) {
      let lat = place.geometry.location.lat()
      let lng = place.geometry.location.lng()
      this.currentPlace = {
        lat: lat,
        lng: lng,
        address:  place.formatted_address,
        country:  this.getPlaceData(place.address_components, 'country'),
        province:  this.getPlaceData(place.address_components, 'administrative_area_level_1'),
        city:  this.getPlaceData(place.address_components, 'administrative_area_level_2'),
        area:  this.getPlaceData(place.address_components, 'administrative_area_level_3'),
      }
      this.center = this.currentPlace
    },
    getPlaceData(data, search) {
      const results = data.filter(x => x.types.includes(search))
      if (results.length > 0) {
        return results.pop()
      }
      return null
    },
    saveCoordinate() {
      this.model.listings[this.locationIndex].latitude = this.currentPlace.lat
      this.model.listings[this.locationIndex].longitude = this.currentPlace.lng
      this.model.listings[this.locationIndex].city = this.currentPlace.city.long_name
      this.model.listings[this.locationIndex].area = this.currentPlace.area.long_name
      // this.model.listings[this.locationIndex].location = this.currentPlace.address
      this.currentPlace = null
      this.locationIndex = null
      this.isCoordinatSet = true
      this.toggleModalCoordinate()
    },
    closeModalCoordinate() {
      this.currentPlace = null
      this.locationIndex = null
      this.toggleModalCoordinate()
    },
    toggleModalCoordinate() {
      this.showModalCoordinate = !this.showModalCoordinate
    },
    openModalCoordinate(index) {
      this.locationIndex = index
      this.toggleModalCoordinate()
    },
    goToListCampaign() {
      this.$router.push({ name: 'campaignmonitoring' })
    },
    validate() {
      
    },
    countPlacement(placements){
      if (placements) return placements.length
    },
    addListing(listing) {
      this.model.listings.push(
        {
          location: '',
          placements: [{item: ''}],
          coordinate: ''
        }
      )
    },
    addPlacement(listing) {
      listing.placements.push(
        {
          item: null
        }
      );
    },
    deleteListing(listing, index) {
      if (listing.length > 1) {
        listing.splice(index, 1);
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    deletePlacement(listing, index){
      if (listing.placements.length > 1) {
        listing.placements.splice(index, 1);
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    saveCampaign() {
      let isValid = triggerValidation(this.model, this.dataRef, this.$refs, this.errors)
      if (isValid) {
        if (!this.campaignDate.start) {
          this.startDateIsValid = false
          // console.log('NOT VALID START DATE')
          return
        }
        if (!this.campaignDate.end) {
          this.endDateIsValid = false
          // console.log('NOT VALID END DATE')
          return
        }
        const start = moment(this.campaignDate.start).format('YYYY-MM-DD')
        const end = moment(this.campaignDate.end).format('YYYY-MM-DD')
        let tempListing_set = []
        this.model.listings.map(x =>{
          x.placements.map(el => {
            let listFinal = null
            if (x.id && el.id){
              listFinal = {
                area: x.area,
                city: x.city,
                latitude: x.latitude,
                longitude: x.longitude,
                location_name: x.location,
                start: start,
                end: end,
                placement: el.item,
                id: x.id
              }
            } else {
              listFinal = {
                area: x.area,
                city: x.city,
                latitude: x.latitude,
                longitude: x.longitude,
                location_name: x.location,
                start: start,
                end: end,
                placement: el.item
              }
            }
            tempListing_set.push(listFinal) 
          })
        })
        const body = {
          title: this.model.titleinput,
          start: start,
          end: end,
          owner: this.model.owner,
          listing_set: tempListing_set
        }
        // console.log('body data', body)
        this.submit(body)
      } else {
      }
    },
    submit(body) {
      (async () => {
        this.isLoading = true
        const response = await api.put(apiV2.taskManagerCampaignEdit(this.id), body,{needToken: true})
        // console.log('response', response)
        if (response.status == 200 || response.status == 201) {
          this.isLoading = false
          this.goToListCampaign()
        } else {
          this.isLoading = false
          if (response.status == 400) {
            const { error } = response.data
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: response.data.start? response.data.start[0] : (response.data.end? response.data.end[0]: (response.data.non_field_errors? response.data.non_field_errors[0] : 'Save Campaign failed')),
              type: 'danger'
            });
          } else if (response.status == 404) {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Ticket Not Found',
              type: 'danger'
            });
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Sorry something went wrong! (Error code: ${response.status})`,
              type: 'warn'
            })
          }
        }
      })();
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>